import { render } from "./ScrollButtons.vue?vue&type=template&id=6348f6dd&ts=true"
import script from "./ScrollButtons.vue?vue&type=script&lang=ts"
export * from "./ScrollButtons.vue?vue&type=script&lang=ts"

import "./ScrollButtons.vue?vue&type=style&index=0&id=6348f6dd&lang=scss"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.0_webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__